import ReactDOM from 'react-dom/client';
import App from './components/pages/App';
import * as serviceWorker from './serviceWorker';
import 'styles/index.scss';
import 'styles/global-ant.less';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
